import { render } from "./index.vue?vue&type=template&id=78cbccb0"
import script from "./text-card-block.js?vue&type=script&lang=js"
export * from "./text-card-block.js?vue&type=script&lang=js"

import "./text-card-block.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__